(function () {
  if (window.__mpnP4xLine) return; window.__mpnP4xLine = true;
  var lang = (document.documentElement.lang || 'fr').slice(0, 2);
  var W = {
    fr: { exact: '4× [x] € sans frais · ou 12×', approx: '4× ≈ [x] € sans frais · ou 12×', min: 'Paiement en 4× ou 12× dès 50 €' },
    en: { exact: '4× [x] € no fees · or 12×', approx: '4× ≈ [x] € no fees · or 12×', min: 'Pay in 4× or 12× from 50 €' },
    de: { exact: '4× [x] € zinsfrei · oder 12×', approx: '4× ≈ [x] € zinsfrei · oder 12×', min: 'Zahlung in 4× oder 12× ab 50 €' }
  }[lang] || null;
  if (!W) W = { exact: '4× [x] € sans frais · ou 12×', approx: '4× ≈ [x] € sans frais · ou 12×', min: 'Paiement en 4× ou 12× dès 50 €' };
  var ICON = ''; /* pas d'icone carte : on parle de paiement en plusieurs fois, pas de moyen de paiement (Ed) */
  function sync() {
    var c = document.querySelector('.product__info-container');
    if (!c) return;
    var pill = c.querySelector('.mineral-alma-pill') || document.querySelector('.mineral-alma-pill');
    var line = c.querySelector('.mpn-p4x-line');
    /* Texte calcule par la pastille d'origine (theme.liquid) : on reprend son montant, sans rien recalculer */
    var src = pill ? (pill.querySelector('.mineral-alma-text') || pill).textContent : '';
    var m = src.match(/4\s*x\s*([\d\s.,]+)\s*€/i);
    if (!pill) {
      if (line) line.remove();
      c.classList.remove('mpn-p4x-on');
      return;
    }
    /* Sous 50 € (montant absent de la pastille) : on indique le seuil, au meme endroit */
    var txt = W.min;
    if (m) {
      var approx = /environ|about|ca\./i.test(src.split('4')[0]);
      txt = (approx ? W.approx : W.exact).replace('[x]', m[1].trim());
    }
    var details = c.querySelector('.product-buy-buttons__price price-details, .product-buy-buttons__price .product__price-details');
    /* « Voir en details » n'a d'interet que si des produits de pose sont ajoutes au total (ligne kit) :
       sans kit, le lien est masque et la ligne 4x/12x se place seule sous le prix (demande d'Ed, oct. 2026) */
    var kitRow = details && details.querySelector('[data-detail-kit-row]');
    var noKit = !!(kitRow && kitRow.hasAttribute('hidden'));
    if (details) details.classList.toggle('mpn-nokit', noKit);
    var detailsOn = details && !noKit && !details.hasAttribute('hidden') && details.getClientRects().length;
    if (!line) {
      line = document.createElement('button');
      line.type = 'button';
      line.className = 'mpn-p4x-line';
      line.innerHTML = ICON + '<span class="mpn-p4x-t"></span><span class="mpn-p4x-i" aria-hidden="true">i</span>';
      line.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var p = document.querySelector('.mineral-alma-pill');
        if (p) p.click();
      });
    }
    var t = line.querySelector('.mpn-p4x-t');
    if (t.textContent !== txt) t.textContent = txt;
    if (detailsOn) {
      var toggle = details.querySelector('.product__price-details-toggle');
      details.classList.add('mpn-has-p4x');
      line.classList.remove('is-solo');
      if (toggle && toggle.nextElementSibling !== line) toggle.after(line);
      /* Toujours sur la ligne de « Voir en details » : si ca ne tient pas, texte un cran plus petit */
      line.classList.remove('is-tight');
      if (toggle && line.offsetTop > toggle.offsetTop + toggle.offsetHeight / 2) line.classList.add('is-tight');
    } else {
      var row = c.querySelector('.product-buy-buttons__price .product__total-price-row');
      if (!row) return;
      line.classList.add('is-solo');
      /* Sous les lignes de detail ajoutees par d'autres scripts (damier, compose : .mpn-mix-detail...) :
         sinon les deux scripts se disputent la place juste sous le prix et la ligne saute en continu */
      var ref = row;
      while (ref.nextElementSibling && ref.nextElementSibling !== line && /(^|\s)mpn-[a-z-]*detail/.test(ref.nextElementSibling.className || '')) ref = ref.nextElementSibling;
      if (ref.nextElementSibling !== line) ref.after(line);
    }
    c.classList.add('mpn-p4x-on');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  setInterval(sync, 800);
})();
